import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logo from "../../images/lg-logo.svg";

const LoginSidebar = () => {
  return (
    <div className="lg-left-content">
      <img src={logo} alt="logo" />
      <h3>Create connections & grow businesses</h3>
    </div>
  );
};
export default LoginSidebar;
